import store from "@/store";

export const getIsAuthenticated = (): boolean => {
  const accToken = store.getters.GET_AUTH_ACCESS_TOKEN;
  return !!accToken;
};
